import { Card, CardContent, Skeleton } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export const LotteryApplicationCardSkeleton: FC = () => (
  <Card sx={{ borderRadius: 2 }}>
    <CardContent sx={{ p: 5, pb: 2 }}>
      <SkeletonText variant="h5" width="20%" />
      <SkeletonText variant="small" width="100%" />
      <SkeletonText variant="small" width="50%" />
    </CardContent>
    <Skeleton variant="rectangular" height={38} width="100%" />
  </Card>
)
